export const GENERAL = "general";
